import(/* webpackChunkName: "winningStoryTeaser" */ '../../Styles/WinningStories/winningStoryTeaser.scss');
import(/* webpackChunkName: "winningStoriesGallery" */ '../../Styles/WinningStories/winningStoriesGallery.scss');

import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');

await import(/* webpackChunkName: "pagination" */ 'Feature/Common/code/Scripts/Pagination/pagination');

window.am = window.am || {};

window.am.winningStoriesGallery = new function () {
    const that = this;

    const viewportTablet = 768;

    const teaserActiveClass = 'winning-story-teaser--active';
    const previewActiveClass = 'winning-story-teaser__preview--active';
    const previewCoveredClass = 'winning-story-teaser__preview--covered';
    const contentExpandedClass = 'winning-stories-gallery__container-slide-content--expanded';
    const firstRowActiveClass = 'winning-stories-gallery__container-slide-content--first-row-active';
    const secondRowActiveClass = 'winning-stories-gallery__container-slide-content--second-row-active';
    const thirdRowActiveClass = 'winning-stories-gallery__container-slide-content--third-row-active';

    that.init = function () {
        that.initHtmlElements();
        let oldWidth = window.innerWidth;

        window.addEventListener('resize', function () {
            const newWidth = window.innerWidth;;

            if (oldWidth < viewportTablet && newWidth >= viewportTablet
                || oldWidth >= viewportTablet && newWidth < viewportTablet) {
                that.initHtmlElements();
            }

            oldWidth = newWidth;
        });
    };

    that.ensureHeadlineVisibility = function (sender) {
        const headlineElement = $(sender)
            .closest('.winning-stories-gallery')[0];

        const position = headlineElement.getBoundingClientRect();

        if (position.top >= 0) {
            return;
        }

        headlineElement.scrollIntoView();
    }

    that.initHtmlElements = function () {
        const $winningStoriesContainer = $('.winning-stories-gallery__winning-stories-container');

        $winningStoriesContainer.each(function () {
            that.initWinningStoriesContainer($(this));
        });

        $(document).on('click', function (event) {
            const $target = $(event.target);
            if (!$target.closest('.winning-stories-gallery__winning-stories-container').length) {
                const $slickContainers = $('.winning-stories-gallery__slick-container');
                $slickContainers.each(function () {
                    that.resetPreviews($(this));
                });
            }
        });
    };

    that.initWinningStoriesContainer = function ($container) {
        const $initContainer = $container.find('.winning-stories-gallery__teaser-init');
        const $winningStoryTeasers = $initContainer.find('.winning-story-teaser').clone();
        const $previewTeasers = $initContainer.find('.winning-story-teaser__preview').clone();
        const viewportWidth = window.innerWidth;
        const $slickContainer = $container.find('.winning-stories-gallery__slick-container');

        if ($slickContainer.hasClass('slick-initialized')) {
            $slickContainer.slick('unslick');
        }

        $slickContainer.off();
        $slickContainer[0].innerHTML = '';

        const teaserCount = $winningStoryTeasers.length;

        if (teaserCount == 0) {
            return;
        }

        let itemsPerPage = 9;

        if (viewportWidth >= viewportTablet) {
            itemsPerPage = 18;
        }

        const slideCount = Math.ceil(teaserCount / itemsPerPage);
        let globalTeaserIndex = 0;

        for (let slideIndex = 0; slideIndex < slideCount; slideIndex++) {
            const containerSlide = document.createElement('div');
            containerSlide.className = 'winning-stories-gallery__container-slide';

            const containerSlideContent = document.createElement('div');
            containerSlideContent.className = 'winning-stories-gallery__container-slide-content';

            for (let teaserIndex = 0; teaserIndex < itemsPerPage && globalTeaserIndex < teaserCount; teaserIndex++) {
                containerSlideContent.appendChild($winningStoryTeasers[globalTeaserIndex]);
                containerSlideContent.appendChild($previewTeasers[globalTeaserIndex]);
                globalTeaserIndex++;
            }

            containerSlide.appendChild(containerSlideContent);
            $slickContainer[0].appendChild(containerSlide);
        }

        $slickContainer.not('.slick-initialized').slick({
            dots: true,
            prevArrow: $container.find('.pagination-prev'),
            nextArrow: $container.find('.pagination-next'),
            appendDots: $container.find('.pagination-dots'),
            dotsClass: "pagination-dots",
            customPaging: function (slider) {
                return '<button class="pagination-circle"></button>';
            },
            focusOnSelect: true,
            infinite: false,
            focusOnChange: false,
            accessibility: true
        });

        $winningStoryTeasers.each(function () {
            that.initWinningStoryTeaser($(this));
        });

        let currentDisplayedSlide;

        $slickContainer.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            currentDisplayedSlide = currentSlide;
            that.ensureHeadlineVisibility(event.target);
        });

        $slickContainer.on('afterChange', function (event, slick, currentSlide) {
            if (currentDisplayedSlide != currentSlide) {
                that.resetPreviews($slickContainer);
                that.trackClick($slickContainer[0]);
            }
        });

        $slickContainer.on('swipe', function (event, slick, currentSlide) {
            event.preventDefault();
            event.stopPropagation();
        });
    };

    that.initWinningStoryTeaser = function ($winningStoryTeaser) {
        const $slickContainer = $winningStoryTeaser.closest('.winning-stories-gallery__slick-container');
        const $containerSlide = $winningStoryTeaser.closest('.winning-stories-gallery__container-slide');

        const teaserID = $winningStoryTeaser[0].dataset.teaserId;
        const $previewTeaser = $containerSlide.find('.winning-story-teaser__preview[data-teaser-id="' + teaserID + '"]');

        const previewCloseButton = $previewTeaser[0].querySelector('.winning-story-teaser__preview-close-button');

        previewCloseButton.addEventListener('click', function () {
            that.resetPreviews($slickContainer);
        });

        previewCloseButton.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                that.resetPreviews($slickContainer);
            }
        });

        const winningStoryTeaser = $winningStoryTeaser[0];

        let moved = false;
        const downListener = () => {
            moved = false;
        }
        winningStoryTeaser.addEventListener('mousedown', downListener);
        const moveListener = () => {
            moved = true;
        }
        winningStoryTeaser.addEventListener('mousemove', moveListener);
        const upListener = () => {
            if (!moved) {
                that.handleTeaserClick($previewTeaser, $slickContainer, $winningStoryTeaser, $containerSlide, teaserID);
            }
        }

        winningStoryTeaser.addEventListener('mouseup', upListener);

        const previewButton = $winningStoryTeaser[0].querySelector('.winning-story-teaser__preview-button');
        previewButton.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                that.handleTeaserClick($previewTeaser, $slickContainer, $winningStoryTeaser, $containerSlide, teaserID);
            }
        });

        let previewButtonFocusTimeoutHandle;

        previewButton.addEventListener('focus', function (event) {
            clearTimeout(previewButtonFocusTimeoutHandle);

            previewButtonFocusTimeoutHandle = setTimeout(function () {
                const $slickSlide = $containerSlide.closest('.slick-slide');
                const newSlickIndex = $slickSlide.data('slickIndex');

                if (newSlickIndex != $slickContainer.slick('slickCurrentSlide')) {
                    that.resetPreviews($slickContainer);
                    $slickContainer.slick('slickGoTo', newSlickIndex, true);
                    $slickContainer.slick('refresh');
                    previewButton.focus({ focusVisible: true });
                }
            }, 150);
        });
    };

    that.handleTeaserClick = function ($previewTeaser, $slickContainer, $winningStoryTeaser, $containerSlide, teaserID) {
        if ($previewTeaser.hasClass(previewActiveClass)) {
            that.resetPreviews($slickContainer);
            return;
        }
        const $containerSlideContent = $winningStoryTeaser.closest('.winning-stories-gallery__container-slide-content');

        const $activeTeaser = $slickContainer.find('.winning-story-teaser--active');
        const $winningStoryPreviews = $containerSlide.find('.winning-story-teaser__preview');
        const previewRowIndex = $previewTeaser.css('grid-row-start');

        $activeTeaser.removeClass(teaserActiveClass);
        $($winningStoryTeaser[0]).addClass(teaserActiveClass);
        $previewTeaser.addClass(previewActiveClass);

        $winningStoryPreviews.each(function () {
            $(this).removeClass(previewCoveredClass);

            if ($(this).css('grid-row-start') != previewRowIndex) {
                $(this).removeClass(previewActiveClass);
            }

            if ($(this).css('grid-row-start') == previewRowIndex && $(this)[0].dataset.teaserId != teaserID) {
                $(this).removeClass(previewActiveClass);
                $(this).addClass(previewCoveredClass);
            }
        });

        $containerSlideContent.removeClass(contentExpandedClass);
        $containerSlideContent.removeClass(firstRowActiveClass);
        $containerSlideContent.removeClass(secondRowActiveClass);
        $containerSlideContent.removeClass(thirdRowActiveClass);

        if ($previewTeaser.hasClass(previewActiveClass)) {
            $containerSlideContent.addClass(contentExpandedClass);
            switch (previewRowIndex) {
                case "2":
                    $containerSlideContent.addClass(firstRowActiveClass);
                    break;
                case "3":
                    $containerSlideContent.addClass(secondRowActiveClass);
                    break;
                case "4":
                    $containerSlideContent.addClass(thirdRowActiveClass);
                    break;
            }
        }

        that.trackClick($winningStoryTeaser[0]);
    }

    that.resetPreviews = function ($slickContainer) {
        const $containerSlides = $slickContainer.find('.winning-stories-gallery__container-slide');
        $containerSlides.each(function () {
            const $containerSlideContent = $(this).find('.winning-stories-gallery__container-slide-content');
            $containerSlideContent.removeClass(contentExpandedClass);
            $containerSlideContent.removeClass(firstRowActiveClass);
            $containerSlideContent.removeClass(secondRowActiveClass);
            $containerSlideContent.removeClass(thirdRowActiveClass);

            const $winningStoryTeasers = $(this).find('.winning-story-teaser');
            $winningStoryTeasers.each(function () {
                $(this).removeClass(teaserActiveClass);
            });

            const $winningStoryPreviews = $(this).find('.winning-story-teaser__preview');
            $winningStoryPreviews.each(function () {
                $(this).removeClass(previewCoveredClass);
                $(this).removeClass(previewActiveClass);
            });
        });
    };

    that.trackClick = function (element) {
        const eventId1 = element.dataset.eventId1;
        const eventId2 = element.dataset.eventId2;

        if (!eventId1) {
            return;
        }

        const utagData = {
            'etracker_event_action': 'click',
            'event_id': eventId1
        };

        if (eventId2) {
            utagData['event_id2'] = eventId2;
        }

        if (typeof utag == "undefined" || !utag) {
            console.debug('debug utagData:', utagData);
        } else {
            utag.link(utagData);
        }
    };
};

window.am.winningStoriesGallery.init();